<template>
  <div class="preika-auth-page">
    <div class="preika-auth-shell">
      <section class="preika-auth-brand">
        <img
          src="/img/avatars/preika.png"
          :alt="productName"
          class="preika-auth-brand__logo"
        >

        <div class="preika-auth-brand__content">
          <p class="preika-auth-brand__eyebrow">PASSWORD UPDATED</p>
          <h1>パスワードの変更が<br>完了しました。</h1>
          <p>
            新しいパスワードで{{ productName }}をご利用いただけます。
            引き続き安全なアカウント管理にご協力ください。
          </p>
        </div>
      </section>

      <section class="preika-auth-form">
        <p class="preika-auth-form__eyebrow">COMPLETE</p>
        <h2>再設定が完了しました</h2>
        <p class="preika-auth-form__description">
          新しいパスワードが登録されました。ログイン画面より再度ログインしてください。
        </p>
        <!--
          **パスワードでのログインを閉じた会社の人もここへ来る**（束23）。
          この画面はどの会社の人か知らないので、条件つきで言う。メールには
          その会社のときだけ「パスワードではログインできません」を書いている。
        -->
        <p class="preika-auth-form__description preika-reset-complete__company-note">
          なお、会社の設定によりパスワードでのログインが停止されている場合は、パスキーまたは連携アカウントをご利用ください（該当する場合はお届けしたメールに記載されています）。
        </p>

        <div class="preika-complete-mark" aria-hidden="true">
          <CIcon name="cil-check-circle"/>
        </div>

        <div class="preika-auth-form__actions preika-auth-form__actions--end">
          <button
            type="button"
            class="btn btn-primary"
            @click="redirectToLogin"
          >
            ログイン画面へ戻る
            <CIcon name="cil-arrow-right"/>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'ResetComplete',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    }
  },

  methods: {
    redirectToLogin () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.preika-complete-mark {
  display: inline-flex;
  width: 74px;
  height: 74px;
  align-items: center;
  justify-content: center;
  margin: 8px 0 18px;
  border-radius: 24px;
  background: var(--preika-success-100);
  color: var(--preika-success-600);
  font-size: 38px;
}

.preika-auth-form__actions--end {
  justify-content: flex-end;
}
</style>
